import { useEffect, useState } from 'react'

interface UseCountUpOptions {
  end: number
  duration?: number
  startOnMount?: boolean
  decimals?: number
}

export function useCountUp({ end, duration = 2000, startOnMount = true, decimals = 0 }: UseCountUpOptions) {
  const [count, setCount] = useState(0)
  const [isComplete, setIsComplete] = useState(false)

  useEffect(() => {
    if (!startOnMount) return

    let startTime: number | null = null
    let animationFrame: number

    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp
      const progress = Math.min((timestamp - startTime) / duration, 1)
      const eased = 1 - Math.pow(1 - progress, 3)
      const current = eased * end

      setCount(Number(current.toFixed(decimals)))

      if (progress < 1) {
        animationFrame = requestAnimationFrame(step)
      } else {
        setIsComplete(true)
      }
    }

    animationFrame = requestAnimationFrame(step)

    return () => cancelAnimationFrame(animationFrame)
  }, [end, duration, startOnMount, decimals])

  return { count, isComplete }
}
